export default {"src":"/_next/static/media/brokenClouds.b56a72da.svg","height":169,"width":169};